"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const Portal_1 = require("../utils/Portal");
const react_use_1 = require("react-use");
const react_if_1 = require("react-if");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const apollo_client_1 = require("apollo-client");
const useOsmosysError_1 = require("../../hooks/useOsmosysError");
const index_1 = require("../index");
const change_case_1 = require("change-case");
const actionsMap = {
    approve: 'approve',
    archive: 'archive',
    create: 'create',
    delete: 'delete',
    read: 'load',
    reject: 'reject',
    update: 'save',
};
exports.OsmosysErrorAlert = (_a) => {
    var { apolloError, resource, action, errorPrefix, noDefaultPrefix = false, pluralResource = false } = _a, props = tslib_1.__rest(_a, ["apolloError", "resource", "action", "errorPrefix", "noDefaultPrefix", "pluralResource"]);
    if (!errorPrefix && !noDefaultPrefix && action && resource) {
        errorPrefix = `${change_case_1.sentenceCase(resource)}${pluralResource ? 's' : ''} failed to ${actionsMap[action]}:`;
    }
    return (react_1.default.createElement(exports.OsmosysAlert, Object.assign({ apolloError: apolloError, dismissable: true, errorPrefix: errorPrefix }, props)));
};
exports.OsmosysAlert = (_a) => {
    var { floatBottom = true, dismissable = false, apolloError, osysIcon = 'exclamation', children, errorPrefix, size, retry, retrying, fake } = _a, props = tslib_1.__rest(_a, ["floatBottom", "dismissable", "apolloError", "osysIcon", "children", "errorPrefix", "size", "retry", "retrying", "fake"]);
    if (process.env.NODE_ENV === 'development' && fake) {
        apolloError = new apollo_client_1.ApolloError({
            errorMessage: 'Faked error!',
            graphQLErrors: [],
            networkError: null,
        });
    }
    const [show, toggleShow] = react_use_1.useToggle(true);
    // showPreviousError
    const [showPreviousError, toggleShowPreviousError] = react_use_1.useToggle(true);
    const [tempSpin, toggleTempSpin] = react_use_1.useToggle(false);
    const errorString = useOsmosysError_1.useOsmosysError(apolloError);
    const prevErrorString = react_use_1.usePreviousDistinct(errorString);
    const prevApolloError = react_use_1.usePreviousDistinct(apolloError);
    const calculatedErrorString = errorString || (showPreviousError ? prevErrorString : '');
    const isOpen = show && (calculatedErrorString || children);
    const btnOpacity = show ? 1 : 0.75;
    react_1.useEffect(() => {
        if (tempSpin) {
            const t = setTimeout(() => {
                toggleTempSpin(false);
            }, 2 * 1000);
            return () => {
                clearTimeout(t);
            };
        }
        return () => { };
    }, [tempSpin]);
    react_1.useEffect(() => {
        if (prevApolloError && !apolloError) {
            toggleShowPreviousError(true);
            const t = setTimeout(() => {
                toggleShowPreviousError(false);
            }, 3 * 1000);
            return () => {
                clearTimeout(t);
            };
        }
        return () => { };
    }, [prevApolloError, apolloError, toggleShowPreviousError]);
    const alert = (react_1.default.createElement(reactstrap_1.Alert, Object.assign({ color: "warning", tag: index_1.OsmosysDiv, osysName: "OsmosysAlert", isOpen: !!isOpen, "data-is-open": isOpen }, props, { transition: {
            mountOnEnter: true,
            timeout: 1000,
            unmountOnExit: true,
        }, className: classnames_1.default(size === 'sm' ? 'py-1 px-2' : size === 'lg' ? 'p-3' : 'p-2', floatBottom ? 'mt-1 mb-2 shadow-sm' : '', 'flex-row') }),
        react_1.default.createElement(index_1.OsmosysDiv, { flexRowFilled: true, style: { opacity: !children && !apolloError ? 0.5 : undefined } },
            react_1.default.createElement(react_if_1.When, { condition: !!osysIcon },
                react_1.default.createElement(index_1.OsmosysDiv, { className: "ml-2 mr-2", flexColCentered: true },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(index_1.OsmosysButton, { osysStyle: "inline", osysName: "alertIcon", osysIcon: osysIcon, iconStyle: "solid", size: size, opacity: btnOpacity })))),
            react_1.default.createElement(index_1.OsmosysDiv, { flexColCenteredFilled: true },
                react_1.default.createElement(index_1.OsmosysDiv, null,
                    react_1.default.createElement("p", { className: "m-0" },
                        react_1.default.createElement(react_if_1.When, { condition: !!errorPrefix },
                            react_1.default.createElement("strong", { className: "mr-2" }, errorPrefix)),
                        children,
                        " ",
                        calculatedErrorString))),
            react_1.default.createElement(react_if_1.When, { condition: !!(retry && typeof retry === 'function') },
                react_1.default.createElement(index_1.OsmosysDiv, { flexColCentered: true, className: "mr-2", style: { opacity: btnOpacity } },
                    react_1.default.createElement(index_1.OsmosysButton, { osysStyle: "inline", osysName: "reload", osysIcon: "reload", disabled: retrying || !retry, iconSpin: tempSpin || retrying, iconStyle: "regular", size: size, onClick: () => {
                            if (retry) {
                                toggleTempSpin(true);
                                retry();
                            }
                        } }))),
            react_1.default.createElement(react_if_1.When, { condition: dismissable },
                react_1.default.createElement(index_1.OsmosysDiv, { flexColCentered: true, className: "mr-2", style: { opacity: btnOpacity } },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(index_1.OsmosysButton, { osysStyle: "inline", osysName: "alertClose", osysIcon: "close", size: size, iconStyle: "regular", onClick: () => {
                                toggleShow(false);
                            } })))))));
    if (floatBottom) {
        return react_1.default.createElement(Portal_1.Portal, { elementID: "alert-portal" }, alert);
    }
    return alert;
};
//# sourceMappingURL=OsmosysAlert.js.map